export default __webpack_public_path__ + "static/media/dot.4adedb0e.svg";